import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getPurchases } from '~/services/OrdersService';
import ReservationService from '~/services/ReservationService';

import { reservationQueryKeys } from './reservationQueryKeys';

interface ResendVCCConfirmationParams {
  bookingNumber: string;
}

export function useResendVCCConfirmation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ bookingNumber }: ResendVCCConfirmationParams) => {
      const response = await getPurchases({
        page: 1,
        per_page: 1,
        brand: null,
        customer_id: null,
        filterBy: 'booking_numbers',
        filterValue: bookingNumber,
      });

      const result = response.result;
      const item = result[0]?.items.find(
        (item) => item.booking_number == bookingNumber,
      );

      if (!item || !item.reservation) {
        throw new Error(
          `Can't fetch reservation for booking number ${bookingNumber}`,
        );
      }

      return await ReservationService.resendVCCConfirmation(item.reservation.id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: reservationQueryKeys.all });
    },
  });
}
